<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="名称或编号">
        <el-input
          v-model="searchModel.keyword"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>

      <el-form-item prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" @onRefresh="getTableData()">
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border height="100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50">
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="检测项目" min-width="200" header-align="center"></el-table-column>
        <el-table-column prop="sampleBelong" label="报告名称" min-width="200" header-align="center"></el-table-column>
        <el-table-column prop="sampleCode" label="模版编号" align="center"></el-table-column>
        <el-table-column prop="createtime" label="创建时间" width="160" align="center"></el-table-column>

        <el-table-column label="操作" width="200" align="center">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDetail(row)">详情</el-link>
            <el-link type="primary" @click="handleEdit(row)">编辑</el-link>
            <el-link type="danger" @click="handleDelete(row)">删除</el-link>
            <br />
            <el-link type="danger" @click="handleDownload(row)">下载报告模版</el-link>
            <el-link type="warning" @click="handleUpload(row)">上传报告模版</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <SampleEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData()" />
    <SampleDetail :visible.sync="detailVisible" :activeId="activeRowId" />
    <UploadTemplate :visible.sync="uploadVisible" :activeInfo="activeRowInfo" @refresh="getTableData()" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import SampleEdit from './components/SampleEdit';
import SampleDetail from './components/SampleDetail';
import UploadTemplate from './components/UploadTemplate';

import { getDictsByCode, getSampleList, deleteSample, queryReportWordTemplate } from '@/api/system';

export default {
  components: { TableHeader, SampleEdit, SampleDetail, UploadTemplate },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        keyword: '',
        sampleType: '',
        etmtType: '',
        type: '',
        dateRange: []
      },
      etmtTypeOptions: [],
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      tableSelection: [],
      // 弹窗
      activeRowId: null,
      activeRowInfo: {},
      detailVisible: false,
      editVisible: false,
      uploadVisible: false
    };
  },
  computed: {},
  watch: {},
  filters: {
    sampleTypeFilter(val) {
      switch (val) {
        case 0:
          return '安全工器具';
        case 1:
          return '施工工器具';
      }
    }
  },
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getSampleList({ ...this.searchModel, startTime, endTime });

      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    // 详情
    handleDetail(row) {
      this.activeRowId = row.id;
      this.detailVisible = true;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteSample({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    },
    async handleDownload(row) {
      const { data } = await queryReportWordTemplate({ modelCode: row.sampleCode });
      const fileUrl = data?.filePath || '';
      this.downloadFile(fileUrl);
    },
    downloadFile(fileUrl) {
      if (!fileUrl) return this.$message.warning('暂无对应文件!');
      const timestamp = new Date().getTime();
      const encodedFileUrl = encodeURIComponent(fileUrl);
      window.open(`${process.env.VUE_APP_BASE_API}/${encodedFileUrl}?t=${timestamp}`, '_blank');
    },
    handleUpload(row) {
      this.activeRowInfo = row;
      this.uploadVisible = true;
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data ?? [];
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
    this.getDictsByCode('etmt_type', 'etmtTypeOptions');
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  .el-table__cell {
    position: relative;
  }
  .logo-box {
    padding-left: 40px;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 40px;
      height: auto;
    }
  }
}
</style>
